import {
  Navigate,
  Outlet,
  useLocation
} from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

export const PrivateRoute = () => {

  const { userToken } = useSelector((state: RootState) => state.authReducer);

  const location = useLocation()

  return (
    !!userToken
      ? <Outlet />
      : <Navigate to="/login" state={{ from: location }} replace />
  )
};